import { render, staticRenderFns } from "./CRMImportHistory.vue?vue&type=template&id=44bfb89f&scoped=true&"
import script from "./CRMImportHistory.vue?vue&type=script&lang=js&"
export * from "./CRMImportHistory.vue?vue&type=script&lang=js&"
import style0 from "./CRMImportHistory.vue?vue&type=style&index=0&id=44bfb89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bfb89f",
  null
  
)

component.options.__file = "CRMImportHistory.vue"
export default component.exports